var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 37,
    viewBox: "0 0 48 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 13.6653L36.854 2.24866C36.367 1.47048 35.656 1 34.907 1H13.093C12.344 1 11.633 1.47048 11.146 2.24767L1 13.6663V22.8367H47V13.6653Z",
    stroke: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.613 16.8126C33.613 15.2195 34.607 13.9043 35.84 13.9033H47V31.9057C47 34.0129 45.68 35.74 44.05 35.74H3.95C2.32 35.74 1 34.0119 1 31.9057V13.9033H12.16C13.393 13.9033 14.387 15.2165 14.387 16.8096V16.8314C14.387 18.4245 15.392 19.7109 16.624 19.7109H31.376C32.608 19.7109 33.613 18.4126 33.613 16.8195V16.8126V16.8126Z",
    fill: "#FAFAFA",
    stroke: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListContent);
export default __webpack_public_path__ + "static/media/list-content.19a1ca58f8b123f10b7aa666563dded6.svg";
export { ForwardRef as ReactComponent };